import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

// Same mode navigation on the landing page and the comparison form.
export default function AnalysisModeSwitch({ mode, onAnalyze, onCompare, compareHref }) {
  const { language } = useLanguage();
  const labels = language === 'cs' ? ['Analyzovat web', 'Porovnat domény'] : ['Analyze website', 'Compare domains'];
  const base = 'px-4 py-2 rounded-lg transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-cyan-400';
  const active = 'bg-cyan-500/20 text-cyan-800 dark:text-cyan-200 border border-cyan-400/50';
  const inactive = 'text-slate-600 dark:text-slate-300 hover:text-cyan-700 dark:hover:text-cyan-200 hover:bg-cyan-500/10 border border-transparent';

  return (
    <div role="group" aria-label={language === 'cs' ? 'Režim měření' : 'Measurement mode'}
      className="inline-flex max-w-full items-center gap-1 p-1 rounded-xl border border-slate-300 dark:border-slate-700 bg-white/80 dark:bg-slate-900/80 text-xs sm:text-sm font-semibold">
      <button type="button" aria-pressed={mode === 'analyze'} onClick={onAnalyze}
        className={`${base} ${mode === 'analyze' ? active : inactive}`}>
        {labels[0]}
      </button>
      {compareHref ? (
        <a href={compareHref} aria-current={mode === 'compare' ? 'page' : undefined}
          onClick={onCompare} className={`${base} ${mode === 'compare' ? active : inactive}`}>
          {labels[1]}
        </a>
      ) : (
        <button type="button" aria-pressed={mode === 'compare'} onClick={onCompare}
          className={`${base} ${mode === 'compare' ? active : inactive}`}>
          {labels[1]}
        </button>
      )}
    </div>
  );
}